import React, { useState, useEffect } from 'react';
import styles from '@/styles/SideBarNav.module.scss';
import {
  SideBarNavItemType,
  useWindowSize,
  sideBarNavElements,
  instituteRecordInfo,
} from '@/common';
import { SideBarNavItem } from './SideBarNavItem';
import { getConditionalStatusWithPartnerStatus } from '@/utils';
import { useAppContext } from '@/components';
import { useSticky } from '@/common';

export const SideBarNav = () => {
  const { state, dispatch } = useAppContext();
  const { width } = useWindowSize();
  const [isActive, setIsActive] = useState('');
  useSticky(width, 'bread-crumb', 'sidebarelements', 'footer');

  function navigateToDifferentPart(newIsActive: string) {
    setIsActive(newIsActive);
  }

  const { partnerStatus, recordsInfo } = state;

  useEffect(() => {
    sideBarNavElements.map(({ title, value }) => {
      if (value !== 'LP' && value !== 'GP') {
        const isVisible: boolean = recordsInfo[value as keyof instituteRecordInfo];
        if (isActive.length === 0 && isVisible) {
          setIsActive((prevtitle) => (prevtitle.length === 0 ? title : prevtitle));
        }
      }
    });
  }, [dispatch, isActive.length, recordsInfo]);

  const toVerifyShowHeadings = (value: string) => {
    let isVisible: boolean = true;
    if (value === 'LP') {
      isVisible =
        recordsInfo['fund-commitment' as keyof instituteRecordInfo] ||
        recordsInfo['investment-appetite' as keyof instituteRecordInfo];
    }
    if (value === 'GP') {
      isVisible = recordsInfo['funds-managed' as keyof instituteRecordInfo];
    }

    return isVisible;
  };

  return (
    <nav className={styles.container} id='sidebar'>
      <ul id='sidebarelements' className={styles.sidebar} data-testid='nav_items'>
        {React.Children.toArray(
          sideBarNavElements.map(({ title, url, parent = '', value = '' }: SideBarNavItemType) => {
            let isValidToDisplay: boolean = getConditionalStatusWithPartnerStatus(
              value,
              partnerStatus
            );

            if (isValidToDisplay && value !== 'LP' && value !== 'GP') {
              isValidToDisplay = recordsInfo[value as keyof instituteRecordInfo];
            }

            if (value === 'LP' || value === 'GP') {
              isValidToDisplay = toVerifyShowHeadings(value);
            }

            return (
              <>
                {isValidToDisplay && isActive ? (
                  <SideBarNavItem
                    title={title}
                    url={url}
                    parent={parent}
                    width={width ?? 1440}
                    isActive={isActive}
                    navigateToDifferentPart={navigateToDifferentPart}
                  />
                ) : (
                  <></>
                )}
              </>
            );
          })
        )}
      </ul>
    </nav>
  );
};
